module.exports = __webpack_public_path__ + "static/media/tagRight.aea6b79f.svg";